export const MonthName = {
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
} as const;
Object.freeze(MonthName);

export type MonthName = (typeof MonthName)[keyof typeof MonthName];

/**
 * The value of month corresponds to the position of its label element.
 *
 * @example - MonthNames[Month.January] returns 'January';
 */
export const MonthNames = Object.values(MonthName);
Object.freeze(MonthNames);
